import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Box, BoxProps } from 'components/Box'
import { useViewport } from 'hooks'

export type ToolbarHeaderProps = React.PropsWithChildren<BoxProps>

// TODO: Should we merge this with components/Page/PageHeader?
export const ToolbarHeader: React.FC<ToolbarHeaderProps> = ({ children, sx }) => {
  const { isMedium } = useViewport()
  const [ domReady, setDomReady ] = useState(false)

  useEffect(() => {
    setDomReady(true)
  }, [])

  if (isMedium) {
    return <Box sx={[
      // () => ({}),
      ...(Array.isArray(sx) ? sx : [sx])
    ]}>
      { children }
    </Box>
  } else {
    return <>
      { domReady && createPortal(<Box sx={[
        () => ({
          flexGrow: 1,
          px: 1,

          '& .MuiTypography-h4': {
            fontSize: '1.5rem',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}>
        { children }
      </Box>, document.getElementById('PageNavBarPortal')) }
    </>
  }
}